'use client'

import {
  buildRecruiterPersonMatchPath,
  buildRecruiterPersonMatchBackPath,
  getHrefWithThreadPreservation,
} from '@yeshuman/sdk'
import type { RecruiterPersonMatchOrigin } from '@yeshuman/sdk'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export type RecruiterPersonMatchLocationState = {
  label?: string
  origin?: RecruiterPersonMatchOrigin
  briefId?: string
  backPath?: string
}

export type NavigateToRecruiterPersonOptions = {
  origin?: RecruiterPersonMatchOrigin
  briefId?: string | null
  evaluationId?: string | null
}

function buildRecruiterPersonNavigationState(
  label: string,
  options?: NavigateToRecruiterPersonOptions,
): RecruiterPersonMatchLocationState {
  const origin = options?.origin ?? (options?.briefId ? 'brief' : 'talent')
  const briefId = options?.briefId ?? undefined
  return {
    label,
    origin,
    briefId,
    backPath: buildRecruiterPersonMatchBackPath(origin, briefId),
  }
}

export function useNavigateToRecruiterPerson(options?: {
  origin?: RecruiterPersonMatchOrigin
  briefId?: string | null
}) {
  const navigate = useNavigate()
  const defaultOrigin = options?.origin
  const defaultBriefId = options?.briefId

  return useCallback(
    (profileId: string, label: string, evaluationId?: string | null) => {
      const origin = defaultOrigin ?? (defaultBriefId ? 'brief' : 'talent')
      const briefId = defaultBriefId ?? undefined
      const path = buildRecruiterPersonMatchPath(profileId, {
        briefId,
        evaluationId: evaluationId ?? undefined,
        tab: evaluationId ? 'analysis' : undefined,
      })
      navigate(getHrefWithThreadPreservation(path), {
        state: buildRecruiterPersonNavigationState(label, {
          origin,
          briefId,
          evaluationId,
        }),
      })
    },
    [defaultBriefId, defaultOrigin, navigate],
  )
}
